module.exports = __webpack_public_path__ + "static/media/supergarante.8a2c7135.svg";